export const environment = {
  production: false,
  apiUrl: 'https://gxkjz4ypp9.execute-api.us-east-1.amazonaws.com/dev',
  version: '1.0.82'
};
